import React from "react";
import { ReactComponent as Logout } from "assets/images/signout.svg";
import { User } from "../User";
import { Container } from "./Styled";

export const UserProfile: React.FC = () => {
  return (
    <Container>
      <User />
      <div className="fo__navbar-logout" onClick={() => window.close()}>
        <Logout />
      </div>
    </Container>
  );
};
